import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { PagedData } from '../models/BaseResponse';
import { CameraSearchCriteria } from '../models/searchCriteria/CameraSearchCriteria';
import { Camera, CameraServiceDTO } from '../models/Camera';

@Injectable({
  providedIn: 'root'
})
export class CameraService {


  constructor(private httpClient: HttpClient) { }

  find(searchCriteria: CameraSearchCriteria): Observable<PagedData<Camera>> {
    return this.httpClient.post<PagedData<Camera>>(environment.apiUrl + "camera/filtered",searchCriteria);
  }

  get(id: number): Observable<Camera> {
    return this.httpClient.get<Camera>(environment.apiUrl + "camera/" + id);
  }

  save(camera: Camera): Observable<void> {
    if (camera.id == 0 || camera.id === undefined) {
      return this.httpClient.post<void>(environment.apiUrl + "camera", camera);
    }
    else {
      return this.httpClient.put<void>(environment.apiUrl + "camera/" + camera.id, camera);
    }
  }
 
  delete(id: number): Observable<void> {
    return this.httpClient.delete<void>(environment.apiUrl + "camera/" + id);
  }
 

  findCameraServiceStarted(): Observable<CameraServiceDTO[]> {
    return this.httpClient.get<CameraServiceDTO[]>(environment.apiUrl + "camera-services/cameraServiceStarted/4portal");
  }

  uploadTsFile(cameraServiceId:number, file:File): Observable<void>{
    let input = new FormData();
    input.append('file', file);
    return this.httpClient.post<void>(environment.apiUrl + "tsUploadedFiles/"+cameraServiceId, input);
  }
}  